<template>
  <div>
    <h1>Lista de Relatorios</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'relatorios_create' }"
            v-if="$can('relatorio:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <b-table striped hover :items="relatorios" :fields="fields" show-empty>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :delete_show="false"
            :view_edit="$can('relatorio:edit')"
            :view_delete="$can('relatorio:delete')"
            edit_to="relatorios_oportunidades"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";

export default {
  components: { Actions },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
    pagination: {
      current_page: 1,
      per_page: 15,
    },
    relatorios: [
      {
        id: "oportunidades",
        nome: "Relatório de Oportunidades",
      },
    ],
  }),
  computed: {
    fields() {
      return [
        { key: "nome", label: "Título" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    searchTerm() {
      this.page = 1;
    },
  },
  async created() {},
};
</script>

<style></style>
